export default __webpack_public_path__ + "three-dots.0ea6624f2053178a.svg";